/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { RowMember_ProjectMembershipFragmentDoc } from './boxes/ProjectOverviewParticipantsBox.generated.js';
import { LastModifiedInfoBoxFragmentDoc } from '../documents/LastModifiedInfo.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectAssigneeSelectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectAssigneeSelectQuery = { organisationSettings: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationSetting', id: string, projectCouldBeUnassigned: boolean }, project: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string } }>, assignee?: { __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> } | null, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> } | null } };

export type ProjectAssigneeSelect_UserQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type ProjectAssigneeSelect_UserQuery = { user?: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'User', id: string, defaultProjectRoles: Array<{ __typename: 'ProjectRole', id: string }> } | null };

export type ProjectAssigneeSelect_AddProjectMemberMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  userId: Types.Scalars['ID']['input'];
  roleIds: Array<Types.Scalars['ID']['input']>;
}>;


export type ProjectAssigneeSelect_AddProjectMemberMutation = { addProjectMemberFromOrganisationMembers: { __typename: 'AddProjectMemberFromOrganisationMembersResult', project: { __typename: 'Project', id: string, lastModified?: { __typename: 'LastModifiedInfo', at: any, by?: { __typename: 'User', id: string, firstname: string, familyname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, url: string } | null } | null } | null, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string } }> } } };

export type ProjectAssigneeSelect_SetProjectAssigneeMutationVariables = Types.Exact<{
  membershipId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectAssigneeSelect_SetProjectAssigneeMutation = { setProjectAssignee: { __typename: 'SetProjectAssigneeResult', project: { __typename: 'Project', id: string, lastModified?: { __typename: 'LastModifiedInfo', at: any, by?: { __typename: 'User', id: string, firstname: string, familyname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, url: string } | null } | null } | null, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string }>, assignee?: { __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> } | null } } };


export const ProjectAssigneeSelectDocument = gql`
    query ProjectAssigneeSelect($projectId: ID!) {
  organisationSettings {
    ... on OrganisationSetting {
      id
      projectCouldBeUnassigned
    }
  }
  project(id: $projectId) {
    ... on ProjectResult {
      project {
        id
        internalStakeholders {
          id
          user {
            id
          }
        }
        assignee {
          id
          ...RowMember_ProjectMembership
        }
        roles {
          id
          internalName
        }
      }
    }
  }
}
    ${RowMember_ProjectMembershipFragmentDoc}`;

/**
 * __useProjectAssigneeSelectQuery__
 *
 * To run a query within a React component, call `useProjectAssigneeSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAssigneeSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAssigneeSelectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectAssigneeSelectQuery(baseOptions: Apollo.QueryHookOptions<ProjectAssigneeSelectQuery, ProjectAssigneeSelectQueryVariables> & ({ variables: ProjectAssigneeSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectAssigneeSelectQuery, ProjectAssigneeSelectQueryVariables>(ProjectAssigneeSelectDocument, options);
      }
export function useProjectAssigneeSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectAssigneeSelectQuery, ProjectAssigneeSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectAssigneeSelectQuery, ProjectAssigneeSelectQueryVariables>(ProjectAssigneeSelectDocument, options);
        }
export function useProjectAssigneeSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectAssigneeSelectQuery, ProjectAssigneeSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectAssigneeSelectQuery, ProjectAssigneeSelectQueryVariables>(ProjectAssigneeSelectDocument, options);
        }
export type ProjectAssigneeSelectQueryHookResult = ReturnType<typeof useProjectAssigneeSelectQuery>;
export type ProjectAssigneeSelectLazyQueryHookResult = ReturnType<typeof useProjectAssigneeSelectLazyQuery>;
export type ProjectAssigneeSelectSuspenseQueryHookResult = ReturnType<typeof useProjectAssigneeSelectSuspenseQuery>;
export type ProjectAssigneeSelectQueryResult = Apollo.QueryResult<ProjectAssigneeSelectQuery, ProjectAssigneeSelectQueryVariables>;
export const ProjectAssigneeSelect_UserDocument = gql`
    query ProjectAssigneeSelect_User($userId: ID!) {
  user(id: $userId) {
    ... on User {
      id
      defaultProjectRoles {
        id
      }
    }
  }
}
    `;

/**
 * __useProjectAssigneeSelect_UserQuery__
 *
 * To run a query within a React component, call `useProjectAssigneeSelect_UserQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAssigneeSelect_UserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAssigneeSelect_UserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProjectAssigneeSelect_UserQuery(baseOptions: Apollo.QueryHookOptions<ProjectAssigneeSelect_UserQuery, ProjectAssigneeSelect_UserQueryVariables> & ({ variables: ProjectAssigneeSelect_UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectAssigneeSelect_UserQuery, ProjectAssigneeSelect_UserQueryVariables>(ProjectAssigneeSelect_UserDocument, options);
      }
export function useProjectAssigneeSelect_UserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectAssigneeSelect_UserQuery, ProjectAssigneeSelect_UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectAssigneeSelect_UserQuery, ProjectAssigneeSelect_UserQueryVariables>(ProjectAssigneeSelect_UserDocument, options);
        }
export function useProjectAssigneeSelect_UserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectAssigneeSelect_UserQuery, ProjectAssigneeSelect_UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectAssigneeSelect_UserQuery, ProjectAssigneeSelect_UserQueryVariables>(ProjectAssigneeSelect_UserDocument, options);
        }
export type ProjectAssigneeSelect_UserQueryHookResult = ReturnType<typeof useProjectAssigneeSelect_UserQuery>;
export type ProjectAssigneeSelect_UserLazyQueryHookResult = ReturnType<typeof useProjectAssigneeSelect_UserLazyQuery>;
export type ProjectAssigneeSelect_UserSuspenseQueryHookResult = ReturnType<typeof useProjectAssigneeSelect_UserSuspenseQuery>;
export type ProjectAssigneeSelect_UserQueryResult = Apollo.QueryResult<ProjectAssigneeSelect_UserQuery, ProjectAssigneeSelect_UserQueryVariables>;
export const ProjectAssigneeSelect_AddProjectMemberDocument = gql`
    mutation ProjectAssigneeSelect_AddProjectMember($projectId: ID!, $userId: ID!, $roleIds: [ID!]!) {
  addProjectMemberFromOrganisationMembers(
    projectId: $projectId
    userId: $userId
    roleIds: $roleIds
  ) {
    project {
      id
      lastModified {
        ...LastModifiedInfoBox
      }
      internalStakeholders {
        id
        user {
          id
        }
      }
    }
  }
}
    ${LastModifiedInfoBoxFragmentDoc}`;
export type ProjectAssigneeSelect_AddProjectMemberMutationFn = Apollo.MutationFunction<ProjectAssigneeSelect_AddProjectMemberMutation, ProjectAssigneeSelect_AddProjectMemberMutationVariables>;

/**
 * __useProjectAssigneeSelect_AddProjectMemberMutation__
 *
 * To run a mutation, you first call `useProjectAssigneeSelect_AddProjectMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectAssigneeSelect_AddProjectMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectAssigneeSelectAddProjectMemberMutation, { data, loading, error }] = useProjectAssigneeSelect_AddProjectMemberMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *      roleIds: // value for 'roleIds'
 *   },
 * });
 */
export function useProjectAssigneeSelect_AddProjectMemberMutation(baseOptions?: Apollo.MutationHookOptions<ProjectAssigneeSelect_AddProjectMemberMutation, ProjectAssigneeSelect_AddProjectMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectAssigneeSelect_AddProjectMemberMutation, ProjectAssigneeSelect_AddProjectMemberMutationVariables>(ProjectAssigneeSelect_AddProjectMemberDocument, options);
      }
export type ProjectAssigneeSelect_AddProjectMemberMutationHookResult = ReturnType<typeof useProjectAssigneeSelect_AddProjectMemberMutation>;
export type ProjectAssigneeSelect_AddProjectMemberMutationResult = Apollo.MutationResult<ProjectAssigneeSelect_AddProjectMemberMutation>;
export type ProjectAssigneeSelect_AddProjectMemberMutationOptions = Apollo.BaseMutationOptions<ProjectAssigneeSelect_AddProjectMemberMutation, ProjectAssigneeSelect_AddProjectMemberMutationVariables>;
export const ProjectAssigneeSelect_SetProjectAssigneeDocument = gql`
    mutation ProjectAssigneeSelect_SetProjectAssignee($membershipId: ID, $projectId: ID!) {
  setProjectAssignee(membershipId: $membershipId, projectId: $projectId) {
    project {
      id
      lastModified {
        ...LastModifiedInfoBox
      }
      internalStakeholders {
        id
      }
      assignee {
        id
        ...RowMember_ProjectMembership
      }
    }
  }
}
    ${LastModifiedInfoBoxFragmentDoc}
${RowMember_ProjectMembershipFragmentDoc}`;
export type ProjectAssigneeSelect_SetProjectAssigneeMutationFn = Apollo.MutationFunction<ProjectAssigneeSelect_SetProjectAssigneeMutation, ProjectAssigneeSelect_SetProjectAssigneeMutationVariables>;

/**
 * __useProjectAssigneeSelect_SetProjectAssigneeMutation__
 *
 * To run a mutation, you first call `useProjectAssigneeSelect_SetProjectAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectAssigneeSelect_SetProjectAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectAssigneeSelectSetProjectAssigneeMutation, { data, loading, error }] = useProjectAssigneeSelect_SetProjectAssigneeMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectAssigneeSelect_SetProjectAssigneeMutation(baseOptions?: Apollo.MutationHookOptions<ProjectAssigneeSelect_SetProjectAssigneeMutation, ProjectAssigneeSelect_SetProjectAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectAssigneeSelect_SetProjectAssigneeMutation, ProjectAssigneeSelect_SetProjectAssigneeMutationVariables>(ProjectAssigneeSelect_SetProjectAssigneeDocument, options);
      }
export type ProjectAssigneeSelect_SetProjectAssigneeMutationHookResult = ReturnType<typeof useProjectAssigneeSelect_SetProjectAssigneeMutation>;
export type ProjectAssigneeSelect_SetProjectAssigneeMutationResult = Apollo.MutationResult<ProjectAssigneeSelect_SetProjectAssigneeMutation>;
export type ProjectAssigneeSelect_SetProjectAssigneeMutationOptions = Apollo.BaseMutationOptions<ProjectAssigneeSelect_SetProjectAssigneeMutation, ProjectAssigneeSelect_SetProjectAssigneeMutationVariables>;